import { FC } from 'react'

import { LogoContainer } from './styles'

const Logo: FC = () => (
  <LogoContainer>
    <h4>Client Portal</h4>
  </LogoContainer>
)

export default Logo
